export const trodlyGreen = "#33cc99";
export const trodlyBorder = "#dfdfdf";
export const trodlyBlack = "#484848";
export const trodlyYellow = "#fdcd26";
export const trodlyBgGrey = "#efefef";
export const troldyFontGrey = "#a0a0a0";
export const trodlyDisabled = "#f7f7f7";


export const trodlyFontLight = 300;
export const trodlyFontRegular = 400;
export const trodlyFontMedium = 500;